import { lazy } from 'react';
import { format_routes } from '@/utils/tools';

// // 供应商申请
const SupplierCenter = lazy(() => import('../pages/supplierCenter/index'));
const SellIndex = lazy(() => import('../pages/quote/main/index'));

//询价回复
const Inquiryreply = lazy(() => import('@/pages/quote/Inquiryreply'));
const InquiryPurchaseFeedback = lazy(() => import('@/pages/quote/Inquiryreply/inquiryPurchaseFeedback'));
const InquiryreplyFeedbackInfo = lazy(() => import('@/pages/quote/Inquiryreply/inquiryPurchaseFeedbackInfo'));
const InquiryPurchaseQuotedInfo = lazy(() => import('@/pages/quote/Inquiryreply/info'));

//竞价回复
const PurchaseRaceReply = lazy(() => import('@/pages/quote/purchaseRace'));
const PurchaseRaceReplyAdd = lazy(() => import('@/pages/quote/purchaseRace/purchaseRaceAdd'));
const PurchaseRaceReplyDetail = lazy(() => import('@/pages/quote/purchaseRace/feedbackInfo'));
const PuchaseRaceDetail = lazy(() => import('@/pages/quote/purchaseRace/puchaseraceDetail'));

//寻源回复
const ProductInquiryReply = lazy(() => import('@/pages/quote/productInquiry/index'));
const ProductInquiryReplyDetail = lazy(() => import('@/pages/quote/productInquiry/productInquiryDetail'));
const ProductInquiryFeedBackInfo = lazy(() => import('@/pages/quote/productInquiry/productInquiryFeedBackInfo'));
const ProductInquiryReplyAdd = lazy(() => import('@/pages/quote/productInquiry/productInquiryAdd'));

// 招投标管理
const BidManage = lazy(() => import('@/pages/bidManage/list'));
const BidManageView = lazy(() => import('@/pages/bidManage/detail'));
const BidManageViewPublic = lazy(() => import('@/pages/bidManage/publish'));
const BidManageUploadFile = lazy(() => import('@/pages/bidManage/component/information'));
const BidReUploadFile = lazy(() => import('@/pages/bidManage/reUploadFile'));

//采购计划管理
const ProcurePlan = lazy(() => import('@/pages/supplierPlan/index'));
const ProcurePlanDetail = lazy(() => import('@/pages/supplierPlan/detail'));

//进出口单据
const ImportDocumentsSupplier = lazy(() => import('@/pages/documents/supplier/index'));
const AddTemplate = lazy(() => import('@/pages/documents/supplier/AddTemplate'));
const ProductRecommendationList = lazy(() => import('@/pages/product/recommendationList'));
const SupplierPriceCenter = lazy(() => import('@/pages/priceCenter/Supplier/index'));
const SupplierPoultryList = lazy(() => import('@/pages/priceCenter/Supplier/poultry/index'));

export const supplierRouter = [
  {
    path: '/supplier/front',
    element: <SellIndex />,
    key: 'SellIndex',
    label: 'Seller Center',
    hidden: false,
  },
  {
    path: '/supplier',
    element: <SupplierCenter />,
    key: 'quotationManagement',
    label: 'Quotation Management', //公司管理,
    children: [
      {
        path: '/supplier/inquiryreply',
        element: <Inquiryreply />,
        key: 'inquiryreply',
        label: 'Inquiry Quotation',
        parentKey: 'quotationManagement',
        hidden: false,
      },
      {
        path: '/supplier/inquiryreply/detail/:inquiry_no',
        element: <InquiryreplyFeedbackInfo />,
        key: 'inquiryreplyFeeabackInfo',
        label: '询价回复详情',
        parentKey: 'quotationManagement',
        hidden: true,
      },
      {
        path: '/supplier/inquiryreply/add',
        element: <InquiryPurchaseFeedback />,
        key: 'inquiryPurchaseAdd',
        label: '询价回复新增',
        parentKey: 'quotationManagement',
        hidden: true,
      },
      {
        path: '/supplier/inquiryreply/feedback/info/:inquiry_feedback_no',
        element: <InquiryPurchaseQuotedInfo />,
        key: 'inquiryPurchaseQuotedInfo',
        label: '询价回复报价单详情',
        parentKey: 'quotationManagement',
        hidden: true,
      },
      {
        path: '/supplier/purchaseracereply',
        element: <PurchaseRaceReply />,
        key: 'purchaseRaceReply',
        parentKey: 'quotationManagement',
        label: 'Bidding Quotation',
      },
      {
        path: '/supplier/purchaseracereply/add',
        element: <PurchaseRaceReplyAdd />,
        key: 'purchaseRaceReplyAdd',
        label: '竞价回复添加',
        parentKey: 'quotationManagement',
        hidden: true
      },
      {
        path: '/supplier/purchaseracereply/quoted/detail/:race_feedback_no',
        element: <PurchaseRaceReplyDetail />,
        key: 'purchaseRaceReplyDetail',
        label: '已报价回复详情',
        parentKey: 'quotationManagement',
        hidden: true
      },
      {
        path: '/supplier/purchaseracereply/detail/:race_no',
        element: <PuchaseRaceDetail />,
        key: 'puchaseRaceDetail',
        label: '竞价回复详情',
        parentKey: 'quotationManagement',
        hidden: true
      },
      {
        path: '/supplier/productreply',
        element: <ProductInquiryReply />,
        key: 'productInquiryReply',
        parentKey: 'quotationManagement',
        label: 'Sourcing Reply',
      },
      {
        path: '/supplier/productreply/detail/:origin_no',
        element: <ProductInquiryReplyDetail />,
        key: 'productInquiryReplyDetail',
        label: '商品寻源详情',
        parentKey: 'quotationManagement',
        hidden: true
      },
      {
        path: '/supplier/productreply/info/:origin_feedback_no',
        element: <ProductInquiryFeedBackInfo />,
        key: 'productInquiryFeedBackInfo',
        label: '商品寻源回复详情',
        parentKey: 'quotationManagement',
        hidden: true
      },
      {
        path: '/supplier/productreply/add',
        element: <ProductInquiryReplyAdd />,
        key: 'productInquiryReplyAdd',
        label: '商品寻源添加',
        parentKey: 'quotationManagement',
        hidden: true
      }
    ]
  },
  {
    path: '/supplier',
    element: <SupplierCenter />,
    key: 'bid',
    label: "Bidding Management", // 招投标管理
    children: [
      {
        path: '/supplier/bid/list',
        element: <BidManage />,
        key: 'bidList',
        label: 'Bidding Management', // 招投标管理
        parentKey: 'bid',
        hidden: false,
      },
      {
        path: '/supplier/bid/list/view/:id/:status?',
        element: <BidManageView />,
        key: 'bidListView',
        label: '项目详情',
        parentKey: 'bid',
        hidden: true,
      },
      {
        path: '/supplier/bid/list/public/:id',
        element: <BidManageViewPublic />,
        key: 'bidListViewPublic',
        label: '中标公示',
        parentKey: 'bid',
        hidden: true,
      },
      {
        path: '/supplier/bid/list/uploadFile/:id',
        element: <BidManageUploadFile />,
        key: 'bidManageUploadFile',
        label: '上传投标文件',
        parentKey: 'bid',
        hidden: true,
      },
      {
        path: '/supplier/bid/list/reUploadFile/:id',
        element: <BidReUploadFile />,
        key: 'reUploadFile',
        label: '重新上传投标文件',
        parentKey: 'bid',
        hidden: true,
      },
    ]
  },
  {
    path: '/supplier',
    element: <SupplierCenter />,
    key: 'planManagementSupplier',
    label: "Procurement Plan Management", // 采购计划管理
    children: [
      {
        path: '/supplier/plan/list',
        element: <ProcurePlan />,
        key: 'planListSupplier',
        label: 'Plan List',
        parentKey: 'planManagementSupplier',
        hidden: false,
      },
      {
        path: '/supplier/plan/list/view/:order_no/:is_international',
        element: <ProcurePlanDetail />,
        key: 'planListSupplierView',
        label: '项目详情',
        parentKey: 'planManagementSupplier',
        hidden: false,
      },
      {
        path: '/supplier/plan/list/quote/:order_no/:is_international',
        element: <ProcurePlanDetail />,
        key: 'planListSupplierView',
        label: '项目详情',
        parentKey: 'planManagementSupplier',
        hidden: false,
      },
    ]
  },
  {
    path: '/supplier',
    element: <SupplierCenter />,
    key: 'importDocumentsSupplier',
    label: "Import and Export Documents",
    children: [
      {
        path: '/supplier/document/list',
        element: <ImportDocumentsSupplier />,
        key: 'documentsListSupplier',
        label: 'Document Management',
        parentKey: 'importDocumentsSupplier',
        hidden: false,
      },
      {
        path: '/supplier/document/list/add/:id/:template_id/:name?',
        element: <AddTemplate />,
        key: 'importAdd',
        parentKey: 'importDocumentsSupplier',
      },
      {
        path: '/supplier/document/list/view/:id/:template_id/:name?',
        element: <AddTemplate />,
        key: 'importAdd',
        parentKey: 'importDocumentsSupplier',
      },
    ]
  },
  {
    path: '/supplier',
    element: <SupplierCenter />,
    key: 'supplierPriceCenter',
    label: 'Supplier Price Center',
    children: [
      {
        path: '/supplier/price/list',
        element: <SupplierPriceCenter />,
        key: 'supplierPorkReport',
        parentKey: 'supplierPriceCenter',
        label: 'Supplier Pork Price Report',
      },
      {
        path: '/supplier/poultry/list',
        element: <SupplierPoultryList />,
        key: 'supplierPoultryList',
        parentKey: 'supplierPriceCenter',
        label: 'Supplier Poultry Price Report',
      },
    ]
  },
  {
    path: '/supplier',
    element: <SupplierCenter />,
    key: 'ProductRecommendation',
    label: "Product Recommendation List",
    children: [
      {
        path: '/supplier/recommendation/list',
        element: <ProductRecommendationList />,
        key: 'ProductRecommendationList',
        label: 'List of imported goods',
        parentKey: 'ProductRecommendation',
      }
    ]
  }
];

export const format_supplier_router_routes = format_routes(supplierRouter);